import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import {
  BOOST,
  INDEED,
  JOVEO,
  POOL,
  SPRING,
  TALROO,
  ZIPRECRUITER,
} from '@/types/channels';
export function useChannelDescription() {
  const intl = useIntl();

  const getDescription = useCallback(
    (channelSlug: string) => {
      switch (channelSlug) {
        case INDEED:
          return intl.formatMessage(
            {
              defaultMessage:
                'Directly sponsor your job on Indeed and receive applicants in Fountain.',
            },
            { description: 'Description of the Indeed channel' },
          );
        case BOOST:
          return intl.formatMessage(
            {
              defaultMessage:
                'Fountain Boost automatically posts your job to hundreds of job boards.',
            },
            { description: 'Description of the Boost channel' },
          );
        case SPRING:
          return intl.formatMessage(
            {
              defaultMessage:
                'Fountain Spring provides job-specific recommendations to sponsor openings to thousands of diverse channels.',
            },
            { description: 'Description of the Spring channel' },
          );
        case TALROO:
          return intl.formatMessage(
            {
              defaultMessage:
                'Talroo is a job board that specializes in finding candidates for tech jobs.',
            },
            { description: 'Description of the Talroo channel' },
          );
        case ZIPRECRUITER:
          return intl.formatMessage(
            {
              defaultMessage:
                'ZipRecruiter is a one-stop hiring platform for businesses of all sizes.',
            },
            { description: 'Description of the ZipRecruiter channel' },
          );
        case JOVEO:
          return intl.formatMessage(
            {
              defaultMessage:
                'Joveo is an AI-led, high-performance recruitment marketing platform.',
            },
            { description: 'Description of the Joveo channel' },
          );
        case POOL:
          return intl.formatMessage(
            {
              defaultMessage:
                'Pool helps you tap into everyone who has ever applied, referred, or worked for you so you can rehire faster.',
            },
            { description: 'Description of the Pool channel' },
          );
        default:
          return null;
      }
    },
    [intl],
  );

  return { getDescription };
}
